export const ReportTypeEnum = {
    STATE_ORDER: {code: 'STATE_ORDER', nameRu: "Расчет госзаказа ОВПО"},
    STATE_ORDER_1COURSE: {code: 'STATE_ORDER_1COURSE', nameRu: "Расчет госзаказа ОВПО(первый курс)"},
    ECO_PAYMENT_REPORT: {code: 'ECO_PAYMENT_REPORT', nameRu: "Экологическая выплата в рамках госзаказа ОВПО"},
};
